/* src/app/main/pages/about/about-banner/about-banner.component.css */
.apps-banner-row {
  background-image: url(/assets/images/about/about-us-banner.png);
  height: 610px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-bottom: 10px solid #F2F2F2;
}
.apps-banner-row h1 {
  font-size: 56px;
}
.apps-banner-row p {
  font-family: "D-DIN-Bold";
  font-size: 31.9px;
  font-weight: 600;
}
@media (min-width: 1680px) {
  .apps-banner-row {
    height: 810px;
  }
}
@media (min-width: 1600px) {
  .apps-banner-row h1 {
    font-size: 89px;
  }
  .apps-banner-row p {
    font-size: 50.9px !important;
  }
}
@media (min-width: 1440px) {
  .apps-banner-row p {
    font-size: 36px;
  }
}
@media (max-width: 768px) {
  .apps-banner-row {
    height: 300px;
  }
}
@media (max-width: 767px) {
  .apps-banner-row p {
    font-size: 20px;
  }
  .apps-banner-row h1 {
    font-size: 34px;
  }
}
/*# sourceMappingURL=about-banner.component.css.map */
